export const en = {
    'empty-rate': 'Not specified',
    title: 'Edit bid'
};
